import routes from 'app/zapbook/routes';

export default {
  routes,
};
